<template>
  <div class="recharge-page">
    <!-- 顶部导航 -->
    <div class="header">
      <img src="/img/newLogin/download.png" @click="back()" class="back-icon" />
      <span class="title">{{ $t('recharge.recharge') || 'Recharge' }}</span>
      <img src="/img/kefu.png" @click="$router.push('/ServiceOnline')" class="service-icon" />
    </div>

    <!-- 余额背景横幅 -->
    <div class="balance-banner">
      <div class="balance-content">
        <span class="balance-val">{{ $money(balance) }}</span>
        <span class="balance-label">{{ $t('my.balance') || 'Balance' }}</span>
      </div>
    </div>

    <!-- 主体内容区 -->
    <div class="main-content">
      <!-- 输入金额 -->
      <div class="input-area">
        <span v-if="$i18n.locale !== 'ja'" class="currency-symbol">{{ $currency() }}</span>
        <input 
          type="number" 
          v-model="money" 
          class="money-input" 
          placeholder=""
        />
        <span v-if="$i18n.locale === 'ja'" class="currency-symbol">{{ $currency() }}</span>
      </div>

      <!-- 快速选择金额 -->
      <div class="quick-section">
        <div class="quick-title">{{ $t('recharge.quick_select') || 'Quick select money' }}</div>
        <div class="quick-grid">
          <div
            v-for="amount in quickAmounts"
            :key="amount"
            class="quick-btn"
            :class="{ active: money == amount }"
            @click="selectAmount(amount)"
          >
            {{ amount }}
          </div>
        </div>
      </div>

      <!-- 确认按钮 -->
      <button class="confirm-btn" @click="onSubmit">
        {{ $t('recharge.confirm') || 'Confirm' }}
      </button>

      <!-- 提示语 -->
      <div class="tip-text">
        {{ $t('recharge.tip') || 'Tip: Please contact customer service after recharge' }}
      </div>
    </div>

    <!-- 充值提交成功弹窗：暗金主题自定义弹窗（替换 Vant 默认白底弹窗） -->
    <div v-if="showSuccessModal" class="rc-modal-overlay" @click="closeSuccessModal">
      <div class="rc-modal" @click.stop>
        <div class="rc-modal-title">{{ $t('recharge.recharge') || 'Recharge' }}</div>
        <div class="rc-modal-msg">{{ successMsg }}</div>
        <button class="rc-modal-btn" @click="closeSuccessModal">OK</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RechargePage',

  data() {
    return {
      balance: '0.00',
      money: '',
      submitting: false,
      quickAmounts: [50, 100, 200, 500, 1000, 3000, 5000, 10000, 30000],
      // 充值提交成功弹窗（暗金主题自定义样式）
      showSuccessModal: false,
      successMsg: '',
    }
  },

  mounted() {
    if (this.$route.params.balance) {
      this.balance = this.$route.params.balance
    } else {
      this.getUserBalance()
    }
    // 获取后台配置的快速选择金额（财务管理--充值管理）
    this.getRechargeConfig()
  },

  created() {
    if (!localStorage.getItem('token')) {
      this.$router.push({ path: '/Login' })
    }
  },

  methods: {
    back() {
      window.history.back()
    },

    selectAmount(amount) {
      this.money = amount
    },

    // 关闭充值成功弹窗并清空金额输入
    closeSuccessModal() {
      this.showSuccessModal = false
      this.money = ''
    },

    getUserBalance() {
      this.$http({ method: 'get', url: 'user_info' }).then(res => {
        if (res.code === 200) {
          this.balance = res.data.money || '0.00'
        }
      }).catch(() => {})
    },

    getRechargeConfig() {
      this.$http({ method: 'get', url: 'recharge_config' }).then(res => {
        if (res.code === 200 && res.data && res.data.amounts && res.data.amounts.length) {
          this.quickAmounts = res.data.amounts
        }
      }).catch(() => {})
    },

    onSubmit() {
      const money = parseFloat(this.money)
      if (!money || money <= 0) {
        this.$toast(this.$t('reservation.money_err') || 'Please enter a valid amount')
        return
      }
      // 防止重复提交
      if (this.submitting) return
      this.submitting = true
      // 提交充值订单（待审核，审核通过后金额才会加到账户余额）
      this.$http({ method: 'post', url: 'recharge', data: { money } }).then(res => {
        this.submitting = false
        if (res && res.code === 200) {
          // 弹窗提示：成功提交订单，请联系工作人员确认（暗金主题自定义弹窗）
          // 使用前端 i18n 词条，保证弹窗语言始终与页面语言一致（后端 msg 可能因 lang 头丢失返回日语）
          this.successMsg = this.$t('recharge.submit_success') || (res.msg)
          this.showSuccessModal = true
        } else {
          this.$toast((res && res.msg) || 'Error')
        }
      }).catch(() => {
        this.submitting = false
      })
    },
  },
}
</script>

<style lang="less" scoped>
.recharge-page {
  background-color: #1f1c1f;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Header */
.header {
  height: 100px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 40px;
  background-color: #1f1c1f;
  position: relative;
  z-index: 10;
  
  .back-icon {
    width: 40px;
    height: 30px;
    cursor: pointer;
  }
  
  .title {
    color: #f2c7a0;
    font-size: 36px;
    font-weight: 500;
  }
  
  .service-icon {
    width: 50px;
    height: 50px;
    cursor: pointer;
  }
}

/* Balance Banner */
.balance-banner {
  background: linear-gradient(to right, #e2bb91, #d4a572);
  height: 240px;
  padding: 40px 60px 0;
  box-sizing: border-box;
}

.balance-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  color: #000;
  
  .balance-val {
    font-size: 40px;
    font-weight: bold;
  }
  
  .balance-label {
    font-size: 36px;
    font-weight: bold;
  }
}

/* Main Content */
.main-content {
  flex: 1;
  background-color: #212025;
  border-radius: 40px 40px 0 0;
  margin-top: -60px;
  padding: 60px 40px;
  position: relative;
  z-index: 5;
}

/* Input Area */
.input-area {
  display: flex;
  align-items: center;
  border-bottom: 2px solid #333;
  padding-bottom: 20px;
  margin-bottom: 50px;
  
  .currency-symbol {
    color: #df9452;
    font-size: 56px;
    margin-right: 20px;
    font-weight: 500;
  }
  
  .money-input {
    flex: 1;
    background: transparent;
    border: none;
    color: #fff;
    font-size: 56px;
    outline: none;
    
    &::placeholder {
      color: #555;
    }
  }
}

/* Quick Select */
.quick-title {
  color: #d98d4d;
  font-size: 32px;
  font-weight: bold;
  margin-bottom: 30px;
}

.quick-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  margin-bottom: 60px;
}

.quick-btn {
  background-color: #292d37;
  border-radius: 12px;
  color: #e0e4eb;
  font-size: 36px;
  font-weight: bold;
  width: calc(33.33% - 16px);
  height: 90px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s;
  
  &:active {
    transform: scale(0.95);
  }
  
  &.active {
    background: linear-gradient(to bottom, #d2a473, #b88654);
    color: #3b200b;
  }
}

/* Confirm Button */
.confirm-btn {
  width: 100%;
  height: 100px;
  background: linear-gradient(to bottom, #a08873, #725842);
  border: none;
  border-radius: 12px;
  color: #4a2c1d;
  font-size: 36px;
  font-weight: bold;
  cursor: pointer;
  margin-bottom: 30px;
  transition: all 0.2s;
  
  &:active {
    opacity: 0.9;
    transform: translateY(2px);
  }
}

/* Tip Text */
.tip-text {
  color: #df9452;
  font-size: 26px;
}

/* 充值成功弹窗：暗金主题，与页面整体风格统一
   全站750设计稿规范：字号由postcss换算为vw，正文不小于26px，标题32-48px，禁止媒体查询二次缩放 */
.rc-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.65);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 60px;
  animation: rcFadeIn 0.2s ease-out;
}

.rc-modal {
  width: 100%;
  max-width: 620px;
  background: linear-gradient(160deg, #2d2a2e 0%, #211f22 100%);
  border: 1px solid #766350;
  border-radius: 24px;
  padding: 56px 48px 48px;
  box-sizing: border-box;
  box-shadow: 0 16px 48px rgba(0, 0, 0, 0.55), 0 0 0 4px rgba(230, 185, 138, 0.08);
  animation: rcPopIn 0.25s ease-out;
}

.rc-modal-title {
  font-size: 44px;
  font-weight: bold;
  text-align: center;
  background: linear-gradient(to right, #f3c7a2, #e6b98a);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  letter-spacing: 2px;
  margin-bottom: 36px;
}

.rc-modal-msg {
  font-size: 30px;
  font-weight: 600;
  line-height: 1.6;
  text-align: center;
  color: rgba(255, 255, 255, 0.92);
  word-break: break-word;
  margin-bottom: 48px;
}

.rc-modal-btn {
  display: block;
  width: 100%;
  height: 96px;
  border: none;
  border-radius: 16px;
  background: linear-gradient(to bottom, #efcba7, #dcab76);
  color: #4a2c1d;
  font-size: 34px;
  font-weight: bold;
  letter-spacing: 2px;
  cursor: pointer;
  box-shadow: 0 6px 16px rgba(220, 171, 118, 0.28);
  transition: all 0.2s;

  &:active {
    opacity: 0.88;
    transform: translateY(2px);
  }
}

@keyframes rcFadeIn {
  from { opacity: 0; }
  to   { opacity: 1; }
}

@keyframes rcPopIn {
  from { opacity: 0; transform: scale(0.92) translateY(16px); }
  to   { opacity: 1; transform: scale(1) translateY(0); }
}
</style>
